<script setup>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.min.css";
import { onMounted, ref } from "vue";
import { useUserStore } from "../../../stores/user";
import { useRoute } from "vue-router/auto";
import { setPageTitle } from "../../../utils/pageTitle";
import useInboundOrders from "../../../hooks/useInboundOrders";
import OrderHeader from "../../../components/order/OrderHeader.vue";
import { shortDateWithTimeTz } from "../../../utils/dateUtils";
import InboundOrderLayout from "../../../layouts/InboundOrderLayout.vue";

import { defineEmits } from "vue";
import { AgGridVue } from "ag-grid-vue3";
import { getDefaultColDefs, getDefaultGridOptions } from "@/utils/aggridCommonConfigs";
import { LicenseManager } from "ag-grid-enterprise";
import { connectToServerApi } from "@/utils/agGridUtils";
import { useThemeStore } from "@/stores/themeStore";
const emit = defineEmits(["inboundOrder"]);

LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);

let gridApi;
let context = ref(null);

const { inboundOrder, fetchInboundOrder } = useInboundOrders();
const userStore = useUserStore();
const route = useRoute();
const themeStore = useThemeStore();

const INBOUND_ORDERS_HISTORY_URL = `/inbound_orders/${route.params.id}/order_history`;

const advancedFilterKeys = ["user.name", "created_at", "body"];

onMounted(async () => {
  await fetchInboundOrder(route.params.id).then(() => {
    setPageTitle(`Inbound Order #IN-${inboundOrder.value.id}`);
  });
});

const onGridReady = (params) => {
  gridApi = params.api;
  context.value = {
    apiUrl: INBOUND_ORDERS_HISTORY_URL,
    advancedFilterKeys: advancedFilterKeys,
  };
  gridApi.setGridOption("serverSideDatasource", connectToServerApi());
}

const columnDefs = [
  { headerName: "#", cellDataType: "text", valueGetter: "node.rowIndex + 1", filter: false, sortable: false, floatingFilter: false, width: 50},
  { field: "user.name", headerName: "Name", colId: "user.name", cellDataType: "text",
    cellRenderer: function (params) {
      if (params.data.user.name) {
        return `<a href="/users/${params.data.user.id}">${params.data.user.name}</a>`;
      } else {
        return '';
      }
    },
  },
  {
      field: "created_at", headerName: "Date", colId: "created_at", cellDataType: "text", valueGetter: (params) => {
          return shortDateWithTimeTz(params.data.created_at);
      }
  },
  { field: "body", headerName: "Action", colId: "body", cellDataType: "text", },
];

const defaultColDef = getDefaultColDefs();

const gridOptions = getDefaultGridOptions(columnDefs);
</script>

<template>
  <InboundOrderLayout :inboundOrder="inboundOrder" v-if="inboundOrder">
    <div v-if="userStore.user && inboundOrder" class="px-4">
      <div class="w-100 px-2">
        <div class="w-100">
          <OrderHeader
            orderType="inbound"
            :orderId="inboundOrder.id"
            :status="inboundOrder.order_status.short_label"
          />
        </div>

        <v-card class="mt-4 pa-2 w-auto" elevation="0">
          <v-card-title class="text-h5">Order History</v-card-title>
        </v-card>

        <div class="inbound-order-history">
          <AgGridVue
            style="width: 100%; height: 100%"
            :class="themeStore.agTheme"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            @grid-ready="onGridReady"
            :context="context"
          ></AgGridVue>
        </div>
      </div>
    </div>
  </InboundOrderLayout>
</template>

<style scoped>
.inbound-order-history {
  height: 570px;
  margin-top: 15px;
}
</style>